import React from 'react';
import '../css/styles.css';
import image from '../images/bg.jpeg';

function Hero() {
  return (
    <section
      className="banner"
      style={{
        backgroundImage: `url(${image})`,
        minHeight: '100vh',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="container">
        <div className="row g-0">
          <div className="col-xl-6 col-lg-7 col-12">
            <div className="banner__content">
              <h3>cryptobetcasino.ro</h3>
              <h1>This Domain is For Sale!</h1>
              <p style={{ color: '#ffffff', fontSize: '21px' }}>
                This domain is available for purchase. A perfect opportunity for anyone looking
                to start a project in the online casino industry or in the crypto news and reviews space. <br /><br />
                Contact us for more details.
              </p>
              <a href="tel:+40729321225" className="default-button">
                <span>
                  Call now +40 (729) 321 225 <i className="icofont-phone"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
